<div>
  @if (loading) {
    <p>Authenticating...</p>
  }
  @if (error) {
    <p>{{ error }}</p>
  }
</div>